import React from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectCoverflow, Autoplay, Keyboard, Navigation, Pagination } from 'swiper';
import PodemosAyudar from "../PodemosAyudar/";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import { Img } from "../components/shared/img"
// import "swiper/components/effect-coverflow/effect-coverflow.scss";

SwiperCore.use([EffectCoverflow, Autoplay, Navigation, Pagination, Keyboard]);

/**
 * Este componente no recibe props. Este renderiza la pantalla principal de "¿qué es?". Para esto hace uso de los componentes PodemosAyudar y Img. 
 * @returns {JSXElement} QueEsComponent
 */
const QueEsComponent = () => {
  const { isReady, textosSubSecciones: textosQueEs } = useObtenerSubsecciones('que_es');
  const editoriales = [
    {
      paquete: ['amanuta', 'cidcli', 'babel-libros', 'fondo-de-cultura-economica', 'ediciones-ekare', 'ediciones-el-naranjo', 'makina-editorial', 'tragaluz']
    },
    {
      paquete: ['e-toiles', 'ediciones-sm', 'pehuen', 'la-cifra', 'pequeno-editor', 'iamique', 'zig-zag', 'laguna-libros']
    },
    {
      paquete: ['elibros', 'luabooks', 'silaba', 'editorial-monigote', 'mesa-estandar', 'sexto-piso', 'cataplum-libros', 'taller-de-edicion-rocca']
    },
    {
      paquete: ['la-brujita-de-papel', 'el-salmon-editores', 'mito-estudio-creativo', 'tyto-alba', 'ebooks-patagonia', 'and-then-story-designers', 'ink-robin', 'editorial-circulo-abierto']
    },
    {
      paquete: ['recrealibros', 'ediciones-uniandes', 'editorial-gatomalo', 'editorial-siete-gatos', 'textofilia-ediciones', 'filomena-edita', 'ediciones-uc', 'libros-moviles']
    },
    {
      paquete: ['la-madriguera-del-conejo', 'fundacion-la-palmita', 'alaluna']
    },

  ]

  const portadas = ['Abuela', 'Destino', 'Diario', 'Helena', 'Insectopedia', 'LeoLeon', 'Nubes', 'Problematico', 'Sr', 'Truchafrita']

  /**
   * Esta función crea los enlaces de las editoriales
   * @param {object} slide 
   * @returns {Array<HTMLElement>} arreglo de imagenes 
   */
  const crearEditoriales = (slide) => {
    let items = [];
    for (let i = 0; i < slide.paquete.length; i++) {
      items.push(
        <div className="col-4 col-lg-3 p-1 p-lg-2 focusable-by-children-secondary" key={`editorial-${i}`}>
          <Link to={`/editorial/${slide.paquete[i]}/`}>
            <div className="cover">
              <Img src={`./img/editoriales2/${slide.paquete[i]}.png`} alt={`editorial-${i}`} className="img-fluid"/>
            </div>
          </Link>
        </div>
      )
    }
    return items;
  }


  /**
   * Esta función crea un SwiperSlide con un conjunto de editoriales
   * @returns {Array<HTMLElement>} arreglo de un conjunto de editoriales 
   */
  const crearSlide = () => {
    let items = [];
    for (let i = 0; i < editoriales.length; i++) {
      items.push(
        <SwiperSlide key={`slide-${i}`} >
          <div className="row mx-0">
            {crearEditoriales(editoriales[i])}
          </div>
        </SwiperSlide>
      )
    }
    return items;
  }

  /**
   * Esta función retorna un arreglo con las caraterísticas de Bibliotecas
   * @returns {Array<HTMLElement>} arreglo con los elementos de lista. 
   */
  const puntosBlibioteca = () => {
    const puntos = [];
    if (isReady) {
      const textoPuntos = textosQueEs.adapta.biblioteca.puntos;
      Object.keys(textoPuntos).map((item, index) =>{
        puntos.push(
          <li tabIndex={0} key={`biblioteca${index}`} className="focusable-primary mt-3" dangerouslySetInnerHTML={{ __html:  textoPuntos[item] }}></li>
        )
      })
    }
    return puntos;
  }

  /**
   * Esta función retorna un arreglo con las caraterísticas de Colegios
   * @returns {Array<HTMLElement>} arreglo con los elementos de lista. 
   */
  const puntosColegios = () => {
    const puntos = [];
    if (isReady) {
      const textoPuntos = textosQueEs.adapta.colegios.puntos;
      Object.keys(textoPuntos).map((item, index) =>{
        puntos.push(
          <li tabIndex={0} key={`colegios${index}`} className="focusable-primary mt-3" dangerouslySetInnerHTML={{ __html:  textoPuntos[item] }}></li>
        )
      })
    }
    return puntos;
  }

  return (
    <>
      {isReady &&
        <>
          <div className="main-title primary--bg">
            <div className="container d-flex align-items-center h-100">
                <div className="col-lg-6 px-0">
                  <h1 className="text-title onprimary--color">{textosQueEs?.titulo?.texto || '¿Qué es MakeMake?'}</h1>
                </div>
                <div className="col-6 d-none d-lg-block">
                  <Img src="./img/logo-makemake.png" alt="logo makemake" aria-hidden={true}/>
                </div>
            </div>
          </div>
          <div className="que-es container-fluid main-content px-0 fuente-semibold">
            <div className="seccion-uno position-relative">
              <div className="container">
                <div className="col-lg-10 mx-auto">
                  <p tabIndex={0} className="focusable-secondary important-information titulo-inicial mx-2 font-weight-bold">
                    {textosQueEs?.plataforma_exclusiva?.titulo || 'Una plataforma exclusiva para colegios y bibliotecas'}
                  </p>
                  <div className="contenedor-inicial-que-es mt-3 mt-lg-5 row">
                    <div className="onbackground-primary--color col-lg-6 parrafo-inicial">
                      <img src="./img/que-es/que-es-avion.png" alt="icono avion de papel" />
                      <p><strong>MakeMake</strong> {textosQueEs?.plataforma_exclusiva?.descripcion || 'ofrece una cuidadosa selección de libros de las mejores editoriales de América Latina para promover la lectura crítica y de calidad en niños y jóvenes.'}</p>
                    </div>
                    <div className="col-6 tablet mt-3 mt-lg-0">
                      <img src="./img/que-es/que-es-tablet.png" alt="tablet" className="img-fluid" />
                    </div>
                    <div className="col-6 ninia mt-5 mt-lg-0">
                      <img src="./img/que-es/que-es-ninia.png" alt="niña leyendo" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="seccion-azul-gris pt-2">
              <Link to="/tienda/individual" aria-label={textosQueEs?.botones?.comprar || 'Soy padre de familia y quiero comprar un plan para mis hijos'} className="link-soypadre focusable-secondary mt-3 mb-lg-5 my-lg-0">
                <div className="card-soypadre">
                  <p className="font-weight-bold text-left text-lg-right">{textosQueEs?.botones?.comprar || 'Soy padre de familia y quiero comprar un plan para mis hijos'}</p>
                </div>
              </Link>

              <div className="container px-0">
                <div className="col-lg-10 mx-auto">
                  <div className="row mx-0 p-3">

                    <p className="important-information titulo-dos font-weight-bold">{textosQueEs?.mejores_libros?.titulo || 'Los mejores libros latinoamericanos'}</p>

                    <div className="py-lg-0 py-4 mt-3 mt-lg-5">
                      <p className="subtitulo-rojos text-uppercase">{textosQueEs?.mejores_libros?.editorial?.titulo || 'Calidad editorial'}</p>
                      <p className="onbackground-primary--color">{textosQueEs?.mejores_libros?.editorial?.descripcion || 'Representamos más de 50 editoriales de América Latina de calidad comprobada con reconocimientos a nivel local, regional e internacional.'}</p>
                    </div>

                    <Swiper
                      className="w-100 p-0 mt-3 mt-lg-4 swiper-editoriales"
                      loop={true}
                      preloadImages={true}
                      slidesPerView={1}
                      autoplay={{
                        delay: 2000,
                      }}
                      breakpoints={{
                        526: {
                          slidesPerView: 1,
                          slidesPerGroup: 1
                        },
                        992: {
                          slidesPerView: 1,
                          slidesPerGroup: 1
                        },
                        1400: {
                          slidesPerView: 1,
                          slidesPerGroup: 1
                        }
                      }}
                      pagination={{
                        clickable: true,
                        type: "bullets",
                      }}
                    >
                      {crearSlide()}
                    </Swiper>

                    <div className="col-lg-11 mx-auto py-4 py-lg-0">
                      <p className="subtitulo-rojos mt-5 text-lg-right text-uppercase">{textosQueEs?.mejores_libros?.diversidad || 'Diversidad de géneros y formatos'}</p>
                      <div className="galeria-de-libros py-5" role={"presentation"}>
                        <Swiper
                          autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                          }}
                          centeredSlides={true}
                          // className="swiper-container-coverflow swiper-container-3d"
                          coverflowEffect={{
                            rotate: 10,
                            stretch: 0,
                            depth: 200,
                            modifier: 1,
                            slideShadows: true,
                          }}

                          effect="coverflow"
                          grabCursor={true}
                          loop={true}
                          modules={[Autoplay, EffectCoverflow]}
                          slidesPerView='auto'
                        >
                          {portadas.map((portada, index) => {
                            return (
                              <SwiperSlide key={`portada-${index}`}>
                                <img src={`./img/Portadas/${portada}.jpg`} alt={`portada-${index}`} className="focusable-secondary img-fluid" />
                              </SwiperSlide>
                            )
                          })}
                        </Swiper>
                      </div>
                      <div className="d-flex justify-center align-items-center">
                      <Link to="/" className="btn-catalogo focusable-secondary btn btn-primary py-2 px-4 mx-auto my-4">
                          {textosQueEs?.botones?.catalogo || 'Conoce todo el catálogo'}
                      </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="seccion-tres seccion-amarilla">
              <div className="container">
                <div className="col-lg-9 mx-auto titulo-tres py-lg-2 pb-3 pb-lg-4 text-center">
                  <p className="important-information font-weight-bold my-3">{textosQueEs?.todo_sobre.titulo || 'Conoce todo sobre MakeMake'}</p>
                </div>
                <div className="col-lg-11">
                  <div className="row mx-0">
                    <div className="d-lg-block d-none col-2 col-lg-3 p-0">
                      <Img src="./img/que-es/que-es-astronauta.png" className="img-fluid img-astronauta" alt="astronauta"/>
                    </div>
                    <div className="col-lg-9 p-0">
                      <div className="ratio ratio-16x9">
                        <iframe width="560" height="315" title="video explicativo" src="https://www.youtube.com/embed/k4C0zwjf7A8" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-3 mt-lg-5">
              <div className="container">
                <div className="col-lg-10 mx-auto py-3 py-lg-0">
                  <p className="important-information font-weight-bold text-center">{textosQueEs?.adapta?.titulo || 'MakeMake se adapta a tus necesidades'}</p>
                </div>
                <div className="w-100 pb-lg-3">

                  <div className="row mx-0 p-0">
                    <div className="col-lg-6 p-0 p-lg-5 mb-lg-5 mb-lg-0 plan-biblioteca">
                      <div className="caja-plan p-0 pb-5 position-relative">
                        <div className="caja-plan-header p-1 p-lg-3">
                          <div className="col-10 m-auto d-flex justify-content-center align-items-center">
                            <img src="./img/que-es/que-es-libros.png" className="icon-plan mr-4 img-rendering" alt="icono libros" />
                            <p tabIndex={0} className="focusable-primary d-block caja-titulo font-weight-bold">{textosQueEs?.adapta?.biblioteca?.titulo || 'Plan Biblioteca'}</p>
                          </div>
                        </div>
                        <div className="px-5">
                          <ul className="circle-list px-0">
                            {puntosBlibioteca()}
                          </ul>
                        </div>
                        <div className="boton-mas position-absolute">
                          <Link to="/que-es-bibliotecas" className="focusable-secondary btn btn-primary d-block mx-auto col-10 col-lg-6"> {textosQueEs?.botones?.conoce || 'Conoce más'}</Link>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 p-0 p-lg-5 my-5 my-lg-0 plan-lector">
                      <div className="caja-plan p-0 pb-5 position-relative">
                        <div className="caja-plan-header p-1 p-lg-3">
                          <div className="col-10 m-auto d-flex justify-content-center align-items-center">
                            <img src="./img/que-es/que-es-libreta.png" className="icon-plan mr-4 img-rendering" alt="icono libreta" />
                            <p tabIndex={0} className="focusable-primary d-block caja-titulo font-weight-bold">{textosQueEs?.adapta?.colegios?.titulo || 'Plan Colegios'}</p>
                          </div>
                        </div>
                        <div className="px-5">
                          <ul className="circle-list px-0">
                            {puntosColegios()}
                          </ul>
                        </div>
                        <div className="boton-mas position-absolute">
                          <Link to="/que-es-colegios" className="focusable-secondary btn btn-primary d-block mx-auto col-10 col-lg-6"> {textosQueEs?.botones?.conoce || 'Conoce más'}</Link>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-container demo--instruction-2 py-4 ">
              <div className="row mx-0 py-3">
                <div className="col-lg-8 mx-auto">
                  <div tabIndex={0} role={"region"} className="focusable-secondary align-items-center justify-content-between flex-column">
                    <div className="mx-auto mb-3">
                      <p className="text-center font-weight-bold"> {textosQueEs?.nuestro_plan?.parte_uno || 'Conoce nuestro plan'}</p>
                      <p className="text-center font-weight-bold">{textosQueEs?.nuestro_plan?.parte_dos ||  'de acompañamiento especializado'}</p>
                    </div>
                    <div>
                      <div className="d-flex justify-center align-items-center">
                      <Link to="/club-makemake" className="focusable-secondary btn btn-primary py-2 px-4 d-block mx-auto">
                        {textosQueEs?.botones?.descubrelo || 'Descúbrelo'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container px-0">
              <div className="col-lg-10 mx-auto">
                <div className="row mx-0 flex-column-reverse flex-lg-row">
                  <div className="col-lg-6">
                    <p className="important-information titulo-pormas font-weight-bold py-4 py-lg-5">
                      {textosQueEs?.instituciones?.titulo || 'Instituciones emblemáticas de América Latina y EEUU se conectan a la lectura con MakeMake'}
                    </p>

                    <p className="onbackground-primary--color py-3 pb-5">
                      {textosQueEs?.instituciones?.descripcion ||  'Por más de seis años MakeMake ha ofrecido oportunidades de lectura a una nueva generación de lectores de todas las edades en diferentes colegios y bibliotecas.'}
                    </p>
                  </div>
                  <div className="col-lg-6 px-0 d-flex align-items-center">
                    <Img src="./img/que-es/que-es-mapa.png" alt="mapa" className="img-rendering img-fluid"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PodemosAyudar />
        </>
      }

    </>
  )
}
export default QueEsComponent;